<template>
    <div>
        <div v-if="!initialised" class="d-flex justify-content-center mt-4">
            <strong>Loading...</strong>
            <div class="ml-5 spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="initialised">
            <h5>First can you tell us a little bit about yourself, where and when you would like to visit Donegal and the size of your party</h5>
            <hr>
            <app-client ref="client" v-model="client"></app-client>
            <hr>
            <h5>When will you be visiting Donegal?</h5>
            <app-dates ref="dates"></app-dates>
            <hr>
            <h5>Please indicate the number of guests</h5>
            <app-passengers ref="passengers"></app-passengers>
            
            <div class="row my-4 justify-content-end">
                <button class="btn btn-success mx-1" @click="nextStep">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import appClient from '../start/Client.vue';
import appCounty from '../start/County.vue';
import appDates from '../start/Dates.vue';
import appPassengers from '../start/Passengers.vue';

export default {
    computed: { 
        initialised() {
            return this.$store.state.static.titles.length > 0 && 
                   this.$store.state.static.counties.length > 0;
        },
        client: { 
            get() { 
                return this.$store.state.passengers.client;
            },
            set(value) {
                this.setClient(value);
            }
        },
        county: { 
            get() { 
                return this.$store.state.start.selectedCounty;
            },
            set(value) {
                this.setSelectedCounty(value);
            }
        },
    },
    methods: { 
        ...mapActions([ 'setClient', 'setSelectedCounty' ]),
        nextStep() {
            // if we have validation errors then 
            if (this.$refs.client.$v.$invalid || this.$refs.dates.$v.$invalid || this.$refs.passengers.$v.$invalid) {
                this.$refs.client.$v.$touch()
                this.$refs.dates.$v.$touch();
                this.$refs.passengers.$v.$touch();
                
            } else {
                this.$store.dispatch('nextStep');
            }
        }
    },
    created() {
        this.$store.dispatch('initTitles');
        this.$store.dispatch('initCounties');
    },
    components: {
        appCounty,
        appDates,
        appPassengers,
        appClient
    },
}
</script>